import store from '@/pages/H5/Cloud/store'
import cookies from 'js-cookie'

export const getToken = showtype => {
    const isSDK = showtype == 'sdk'
    const isKP = showtype == 'kp'
    if (isSDK === true) {
        return window?.parent?.sdk_userInfo?.token;
    } else if (isKP === true) {
        return store.state.userInfo.token;
    }
    return cookies.get('token');
}

export const getUserId = showtype => {
    const isSDK = showtype == 'sdk'
    const isKP = showtype == 'kp'
    if (isSDK === true) {
        return window?.parent?.sdk_userInfo?.userId;
    } else if (isKP === true) {
        return store.state.userInfo.userId;
    }
    return cookies.get('userId');
}

export const getDeviceId = showtype => {
    const isSDK = showtype == 'sdk'
    const isKP = showtype == 'kp'
    if (isSDK === true) {
        return window?.parent?.sdk_userInfo?.deviceId;
    } else if (isKP === true) {
        return store.state.userInfo.deviceId;
    }
    return cookies.get('deviceId');
}

export const getSpaceId = showtype => {
    const isSDK = showtype == 'sdk'
    const isKP = showtype == 'kp'
    if (isSDK === true) {
        return window?.parent?.sdk_userInfo?.spaceId;
    } else if (isKP === true) {
        return store.state.userInfo.spaceId;
    }
    return cookies.get('spaceId');
}